/**
 * JSON-LD structured-data injector.
 *
 * Google's SEO crawler reads any <script type="application/ld+json"> element
 * placed anywhere in the DOM (head or body). React renders this inline tag
 * correctly — no react-helmet or head-portal needed.
 *
 * Usage:
 *   <JsonLd data={{ "@context": "https://schema.org", "@type": "FAQPage", ... }} />
 *
 * Pass a single object or an array of objects (the latter is emitted as a
 * @graph). Keep payloads compact — Google deduplicates duplicate keys.
 */
export default function JsonLd({ data, id }) {
  if (!data) return null;
  const payload = Array.isArray(data)
    ? { "@context": "https://schema.org", "@graph": data }
    : data;
  return (
    <script
      type="application/ld+json"
      data-testid={id || "json-ld"}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(payload).replace(/</g, "\\u003c") }}
    />
  );
}
